export default __webpack_public_path__ + "static/topsidemenu01@2x-83fc8696396669389e476a5af5132bd1.png";